/* eslint no-shadow: 0 */
export enum ServiceType {
  COVER = 0,
  ATTENDANCE = 1,
}

export enum ChargeType {
  PERCENTAGE = 0,
  FIXED = 1,
}

export enum ServiceCharge {
  NONE = 0,
  COVER = 1,
  ATTENDANCE_PERCENTAGE = 2,
  ATTENDANCE_FIXED = 3,
}
